import {Component} from '@angular/core';
import {SidebarService} from '../containers/layout/sidebar/sidebar.service';
import {Location, LocationStrategy, PathLocationStrategy} from '@angular/common';
import {environment} from '../../environments/environment';
import {ACTIVE_SETTINGS_TAB, BACK_SETTINGS_REDIRECT, COMPANY_NAME} from '../shared/constants/value';
import {LocalStorageService} from '../shared/services/storage/local-storage/local-storage.service';
import {Router} from '@angular/router';
import {EWALLET_TERMS_OF_SERVICE} from '../shared/constants/links';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
  providers: [
    Location, {provide: LocationStrategy, useClass: PathLocationStrategy},
  ],
})

export class SettingsComponent {

  public currentTab: string = this.localStorageService.read(ACTIVE_SETTINGS_TAB) || 'settings';

  public year: string = new Date().getFullYear().toString();

  public version: string = environment.version;

  public companyName = COMPANY_NAME;

  public isLoading = false;

  public termsOfServiceLink = EWALLET_TERMS_OF_SERVICE;

  constructor(private sidebarService: SidebarService,
              private location: Location,
              private localStorageService: LocalStorageService,
              private router: Router) {
    this.collapsSidebarMenu();
  }

  onTabSelectHandler(value) {
    this.currentTab = value.activeTab;
    this.localStorageService.write(ACTIVE_SETTINGS_TAB, this.currentTab);
  }

  collapsSidebarMenu() {
    setTimeout(() => {
      this.sidebarService.collapse(true);
    }, 100);
  }

  moveBack() {
    this.localStorageService.remove(ACTIVE_SETTINGS_TAB);

    this.isLoading = true;

    this.router.navigateByUrl(this.localStorageService.read(BACK_SETTINGS_REDIRECT) || '')
      .then(() => {
        this.localStorageService.remove(BACK_SETTINGS_REDIRECT);
        this.isLoading = false;
      });
  }
}
